import styled from 'styled-components';

export const CouponListWrapStyle = styled.div``;
